import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "8.5",
  cy: "8.5",
  r: "8.5",
  fill: "#818181"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M12 5.716L11.295 5 8.5 7.839 5.705 5 5 5.716 7.795 8.556 5 11.395 5.705 12.111 8.5 9.272 11.295 12.111 12 11.395 9.205 8.556z"
})), 'CloseCircleFilled', {
  viewBox: '0 0 17 17'
});